import PropTypes from 'prop-types';
import React, { forwardRef, useEffect, useRef } from 'react';
import { useFocusTrap } from '@fenderdigital/custom-hooks';
import Spacer from '@fenderdigital/ui/Spacer';
import Heading from '@fenderdigital/ui/Heading';
import BodyText from '@fenderdigital/ui/BodyText';
import Tablature from '../../../components/Tablature/Tablature';
import FullScreenButton from '../../../components/FullScreenButton/FullScreenButton';
import { getArtistNames } from '../../../components/ProgressList/progress-list-utils';
import * as S from './Lesson-styled';

const renderLessonTitle = (artists, title) => {
  return (
    <S.LessonTitleContent>
      <S.LessonTitleContainer>
        <Spacer spacing="md1" />
        <Heading textSize="f8" id="lesson-title">
          {title}
        </Heading>
        {getArtistNames(artists)}
      </S.LessonTitleContainer>
    </S.LessonTitleContent>
  );
};

const renderTabMeta = (artists, title, onCloseClick) => {
  return (
    <S.LessonTabModalMetaContainer>
      <S.LessonTitleContent>
        {renderLessonTitle(artists, title)}
        <FullScreenButton
          label="Close"
          ariaLabel="Close"
          handleClick={onCloseClick}
          icon="icon-x-thin"
        />
      </S.LessonTitleContent>
      <Heading as="h2" textSize="f3">
        Tablature
      </Heading>
    </S.LessonTabModalMetaContainer>
  );
};

const LessonTabModal = forwardRef(({ tabs, settings, artists, title, onCloseClick }, ref) => {
  const modalContentRef = useFocusTrap();

  return (
    <S.LessonTabModalContainer ref={ref} role="dialog" aria-modal aria-labelledby="lesson-title">
      <S.LessonTabModalContent ref={modalContentRef}>
        {renderTabMeta(artists, title, onCloseClick)}
        <Spacer spacing="md1" />
        <Tablature tabs={tabs} settings={settings} type="song" isFullScreen />
      </S.LessonTabModalContent>
    </S.LessonTabModalContainer>
  );
});

LessonTabModal.propTypes = {
  artists: PropTypes.arrayOf(PropTypes.object),
  onCloseClick: PropTypes.func.isRequired,
  settings: PropTypes.shape({}),
  tabs: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
};

LessonTabModal.defaultProps = {
  title: '',
  artists: [],
  tabs: [],
  settings: null,
};

export default LessonTabModal;
